var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSheet2Red(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #1d1d1b;\n        stroke-width: .25px;\n      }\n\n      .st0, .st1 {\n        stroke: #474747;\n      }\n\n      .st1 {\n        fill: #ea514a;\n        stroke-width: 2px;\n      }\n\n      .st2 {\n        fill: #474747;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5,1.99c0-.55.45-.99,1-.99h17.01c.55,0,1.34.27,1.78.62l3.44,2.75c.43.34.78,1.07.78,1.62v26.01c0,.55-.45,1-1,1H6c-.55,0-1-.45-1-.99V1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22,2h1v6h-1V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22,7h6v1h-6v-1Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,2v5h5s.56-1.94-1.89-3.07-1.47-2.21-3.11-1.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet2Red);
export default __webpack_public_path__ + "static/media/sheet2red.e6e3f17a9dd187ba9699fb3576d40867.svg";
export { ForwardRef as ReactComponent };